import { createTheme } from "@mui/material/styles";
import { LightThemeColors } from "../constants/colors/lightThemeColors";

export const theme = (data) => {
  const { primary, secondary, button, text, chip, background, badges, timeAllocation } =
    data?.colors ?? {};
  return createTheme({
    palette: {
      primary: primary || {
        light: LightThemeColors.primary.light,
        main: LightThemeColors.primary.main,
        dark: LightThemeColors.primary.dark,
      },
      secondary: secondary || {
        light: LightThemeColors.secondary.light,
        main: LightThemeColors.secondary.main,
        dark: LightThemeColors.secondary.dark,
      },
      background: background || {
        default: LightThemeColors.background.default,
        light: LightThemeColors.background.light,
      },
      button: button || {
        main: LightThemeColors.button.main,
      },
      text: text || {
        primary: LightThemeColors.text.primary,
        secondary: LightThemeColors.text.secondary,
      },
      chip: chip || {
        greenShade: LightThemeColors.chip.greenShade,
        redShade: LightThemeColors.chip.redShade,
      },
      badges: badges || LightThemeColors.badges,
      timeAllocation: timeAllocation || LightThemeColors.timeAllocation, // Added timeAllocation colors
    },
    shadows: [...Array(24).fill("none"), "0px 2px 4px 0px hsla(0, 0%, 0%, 0.08)"],
    typography: {
      fontFamily: "Aeonik, Roboto, sans-serif",
      badgeStackHeader: {
        fontFamily: "Aeonik, Roboto, sans-serif",
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "14px",
        textTransform: "uppercase",
      },
      badgeStackBody: {
        fontFamily: "Aeonik, Arial, sans-serif",
      },
      recommendationCardHeader: {
        fontFamily: "Aeonik, Arial, sans-serif",
        fontSize: "14px",
        fontWeight: 700,
        lineHeight: "1.5",
      },
      recommendationCardBody: {
        fontFamily: "Aeonik, Arial, sans-serif",
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "1.5",
      },
      typeNormal: {
        fontFamily: "Aeonik, Roboto, sans-serif",
        fontSize: "16px",
        fontWeight: 400,
      },
      typeBold: {
        fontFamily: "Aeonik, Roboto, sans-serif",
        fontSize: "16px",
        fontWeight: 700,
      },
      typeSmall: {
        fontFamily: "Aeonik, Roboto, sans-serif",
        fontSize: "14px",
        fontWeight: 400,
      }
    },
    components: {
      MuiChip: {
        styleOverrides: {
          label: {
            fontFamily: "Aeonik, Roboto, sans-serif",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            boxShadow: [
              "0px 1px 2px 0px rgba(16, 24, 40, 0.06)",
              "0px 1px 3px 0px rgba(16, 24, 40, 0.1)",
            ],
            borderRadius: "12px",
            border: "1px solid #EAECF0",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: "2px 10px 2px 10px",
          },
        },
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            fontWeight: 500,
          },
        },
      },
      MuiPickersYear: {
        styleOverrides: {
          root: {
            fontWeight: 500,
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            backgroundColor: (theme) => theme.palette.background.paper,
            padding: "0 4px",
            zIndex: 1,
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            position: "relative",
          },
          notchedOutline: {
            borderWidth: "1px",
          },
        },
      },
    },
  });
};
